import {Component, Input, input, OnInit} from '@angular/core';
import {InputNumberModule} from "primeng/inputnumber";

import {TooltipModule} from "primeng/tooltip";
import {FormsModule} from "@angular/forms";
import {AbstractProfileComponent} from "../abstract-profile.component";

@Component({
    selector: 'profile-number',
    imports: [
    InputNumberModule,
    TooltipModule,
    FormsModule
],
    templateUrl: './profile-number.component.html',
    styleUrl: './profile-number.component.scss'
})
export class ProfileNumberComponent extends AbstractProfileComponent implements OnInit {

    constructor() {
        super();
    }

    protected readonly parseInt = parseInt;
    protected readonly String = String;
}
